import { render, staticRenderFns } from "./ExamIndex.vue?vue&type=template&id=3e043382&scoped=true&"
import script from "./ExamIndex.vue?vue&type=script&lang=js&"
export * from "./ExamIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExamIndex.vue?vue&type=style&index=0&id=3e043382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e043382",
  null
  
)

export default component.exports